import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import CustomCursor from "../components/CustomCursor";
import { CameraProvider, SkipToCase } from "../components/investigation/CameraProvider";
import BoardHud from "../components/investigation/BoardHud";
import InvestigationBoard from "../components/investigation/InvestigationBoard";
import EvidenceModalProvider from "../components/investigation/EvidenceModalContext";
import BoardMinimap from "../components/investigation/BoardMinimap";
import { BoardGeometryProvider } from "../components/investigation/BoardGeometry";
import { profile } from "../data/profile";

const PortfolioLayout = () => {
  useEffect(() => {
    document.documentElement.classList.add("board-lock");
    return () => document.documentElement.classList.remove("board-lock");
  }, []);

  return (
    <div className="case-shell case-shell--board">
      <Helmet>
        <title>{`${profile.displayName} — ${profile.title}`}</title>
        <meta
          name="description"
          content={`${profile.displayName} — ${profile.title}. ${profile.summary}`}
        />
      </Helmet>
      <CameraProvider>
        <BoardGeometryProvider>
          <EvidenceModalProvider>
            <CustomCursor />
            <SkipToCase />
            <BoardHud />
            <BoardMinimap />
            <InvestigationBoard />
          </EvidenceModalProvider>
        </BoardGeometryProvider>
      </CameraProvider>
    </div>
  );
};

export default PortfolioLayout;
